import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";
import { Search } from "lucide-react";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);

  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)); }, []);

  const filtered = q
    ? faqs.filter((f) => f.question.toLowerCase().includes(q.toLowerCase()) || f.answer.toLowerCase().includes(q.toLowerCase()))
    : faqs;

  return (
    <PublicLayout>
      <section className="border-b border-border bg-card">
        <div className="max-w-4xl mx-auto px-6 py-16">
          <div className="label-eyebrow text-secondary mb-2">Frequently asked questions</div>
          <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter text-primary leading-none">Vendora answers.</h1>
          <div className="mt-8 relative max-w-xl">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input className="v-input pl-10" placeholder="Search FAQs…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="faq-search" />
          </div>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-6 py-10 space-y-2">
        {filtered.map((f) => (
          <div key={f.id} className="v-card cursor-pointer" onClick={() => setOpen(open === f.id ? null : f.id)} data-testid={`faq-${f.id}`}>
            <div className="flex justify-between items-start gap-4">
              <h3 className="font-display text-lg font-semibold text-primary">{f.question}</h3>
              <span className="text-secondary font-mono text-xl">{open === f.id ? "−" : "+"}</span>
            </div>
            {open === f.id && <p className="mt-3 text-muted-foreground leading-relaxed">{f.answer}</p>}
          </div>
        ))}
        {filtered.length === 0 && <div className="text-center text-muted-foreground py-10">No FAQs match your search.</div>}
      </section>
    </PublicLayout>
  );
}
